import React, { useEffect, useState, useRef } from "react";
import { Button, Form, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-multi-lang";
import {
  setTokenExchangeData,
  exchangeCryptoStart,
  exchangeCryptoSuccess,
  getAdminWalletStart,
  exchangeCryptoHDStart,
} from "../../store/actions/BuyAction";
import { Formik, Form as FORM, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  getErrorNotificationMessage,
  getSuccessNotificationMessage,
} from "../helper/ToastNotification";
import { updateSwapData } from "../../store/actions/UserAction";
import CopyToClipboard from "react-copy-to-clipboard";
import QRCode from "react-qr-code";
import configuration from "react-global-configuration";
import CommonCenterLoader from "../helper/CommonCenterLoader";
import CustomLazyLoad from "../helper/CustomLazyLoad";
import ButtonStepper from "./ButtonStepper";
import {
  SUPPORTED_RPC_URLS,
  CHAIN_INFO,
  SupportedChainId,
  SupportedTokens,
  SPECIAL_CONTRACT_ADDRESS,
} from "../../config/chains";
import { ethers } from "ethers"
import Skeleton from "react-loading-skeleton";
import { io } from "socket.io-client";
import AwaitingStepper from "./AwaitingStepper";
import Web3 from "web3";

const qrcode = require('qrcode');
let socket;
let SOCKET_URL = process.env.REACT_APP_HASH_SOCKET_URL;

const ExchangeWithoutLogin = (props) => {

  const navigate = useNavigate()
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const t = useTranslation("sell_index");

  const tokenExchangeData = useSelector((state) => state.buy.tokenExchangeData);
  const adminWallet = useSelector((state) => state.buy.adminWallet);
  const exchangeCryptoHD = useSelector((state) => state.buy.exchangeCryptoHD);
  const profile = useSelector((state) => state.user.profile);
  const updateTokenExchangeData = (data) => dispatch(setTokenExchangeData(data));

  const [skipRender, setSkipRender] = useState(true);
  const [buttonShow, setButtonShow] = useState(false);
  const [generatedQr, setGeneratedQr] = useState(false);
  const [monitoring, setMonitoring] = useState(false);
  const [tronMonitoring, setTronMonitoring] = useState(false);
  const [solanaMonitoring, setSolanaMonitoring] = useState(false);
  const [transactionSuccess, setTransactionSuccess] = useState(false);
  const [automaticHash, setAutomaticHash] = useState(true);
  const TRANSFER_EVENT_SIG = "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef";

  const validationSchema = Yup.object().shape({
    transaction_hash: Yup.string()
      .required(t("transaction.required"))
      .min(3, t("transaction.invalid"))
    // .max(66, "Max 66 characters allowed"),
  });

  useEffect(() => {
    dispatch(getAdminWalletStart({ network_type: !["USDT", "USDC"].includes(tokenExchangeData.from_currency) ? tokenExchangeData.from_currency : tokenExchangeData.from_network_type, user_id: profile.data?.user_id ? profile.data?.user_id : "" }));
    window.scrollTo(0, 0);
  }, []);

  const onSubmit = (values) => {
    setButtonShow(false);
    dispatch(
      exchangeCryptoHDStart({
        // token: tokenExchangeData.from_amount,
        from_token: tokenExchangeData.from_currency,
        to_token: tokenExchangeData.to_currency,
        receiver_wallet_address: tokenExchangeData.receiver_wallet_address,
        transaction_hash: values.transaction_hash,
        // network_type: tokenExchangeData.network_type,
        from_network_type: tokenExchangeData.from_network_type,
        to_network_type: tokenExchangeData.to_network_type || "",
        from_token_amount: tokenExchangeData.from_amount,
        to_token_amount: tokenExchangeData.to_amount,
      })
    );
  };

  useEffect(() => {
    if (
      !skipRender &&
      !exchangeCryptoHD.loading &&
      Object.keys(exchangeCryptoHD.data).length > 0
    ) {
      setTransactionSuccess(true)
      setButtonShow(false);
      setTimeout(() => {
        if (exchangeCryptoHD.data.exchange.status == 5) {
          updateTokenExchangeData({
            ...tokenExchangeData,
            step: 3,
          })
        }
        else {
          setButtonShow(true);
        }
      }, 4000)


    }
    setSkipRender(false);
  }, [exchangeCryptoHD]);
  
  const getTokenDecimals = async (tokenAddress, provider) => {
    try {
      const erc20Abi = ["function decimals() view returns (uint8)"];
      const contract = new ethers.Contract(tokenAddress, erc20Abi, provider);
      return await contract.decimals();
    } catch (err) {
      console.error(`Error fetching decimals:`, err);
      return 18; // Default if error occurs
    }
  };

  const generateQRDetails = async (wallet_address, token, currency) => {
    let network = token == "TRX" ? "tron" : token == "SOL" ? "solana" : "ethereum"
    const depositAmountInWei = ["TRX", "SOL"].includes(token) ? tokenExchangeData.from_amount.toString() : ["USDC", "USDT"].includes(currency) ? tokenExchangeData.from_amount.toString() : (tokenExchangeData.from_amount.toString());
    console.log(depositAmountInWei, "deposit Amount")
    let depositLabel = "HeraldExchangeSell"
    const uri = `${network}:${wallet_address}?amount=${depositAmountInWei}&label=${encodeURIComponent(depositLabel)}`;
    const qrDataURL = await qrcode.toDataURL(uri);
    if (qrDataURL) {
      setGeneratedQr(qrDataURL)
      return qrDataURL;
    }
  }

  const startMonitoring = async (walletAddress, networkType, expectedAmount, tokenAddress) => {
    let found = false;

    const rpcUrl = SUPPORTED_RPC_URLS[SupportedTokens[networkType]];
    const provider = new ethers.providers.JsonRpcProvider(rpcUrl);

    console.log(`Monitoring ${networkType} for wallet: ${walletAddress} and expected amount: ${expectedAmount}`);

    const blockListener = async (blockNumber) => {
      console.log(`New Block (${networkType}):`, blockNumber);

      const block = await provider.getBlockWithTransactions(blockNumber);
      if (block?.transactions?.length) {
        for (const tx of block.transactions) {
          if (found) break;

          // 🪙 **Case 1: Native Currency Transfer**
          if (!tokenAddress && tx.to?.toLowerCase() === walletAddress.toLowerCase()) {
            const amount = ethers.utils.formatEther(tx.value);
            console.log(`Native Tx: Amount: ${amount} | Expected: ${expectedAmount}`);

            if (amount === expectedAmount) {
              found = true;
              console.log(`✅ Matching native transaction found: ${tx.hash}`);

              if (automaticHash) {
                formRef.current.setFieldValue("transaction_hash", tx.hash);
                onSubmit({ ...formRef.current.values, transaction_hash: tx.hash });
              }

              provider.off("block", blockListener);
              setMonitoring(false);
              return;
            }
          }

          // ** Case 2: Token Transfer**
          if (tokenAddress) {
            const web3 = new Web3(rpcUrl);
            let transReceipt = await web3.eth.getTransactionReceipt(tx.hash);
            // console.log(`Monitoring for token: ${tokenAddress} and expected amount: ${expectedAmount}`);

            do {
                let transReceipt = await web3.eth.getTransactionReceipt(tx.hash);
                if (transReceipt.logs.length > 0) {
                  // console.log("Checking transaction : ", tx.hash)
                  let tokenHexString;
                  for (let index = 0; index < transReceipt.logs.length; index++) {

                    if (transReceipt.logs[index].address.toLowerCase() === tokenAddress.toLowerCase()) {

                      const to = `0x${transReceipt.logs[index].topics[2].slice(26)}`;
                      console.log("Token Transfer to :", to)
      
                      if (to.toLowerCase() === walletAddress.toLowerCase()) {

                        tokenHexString = transReceipt.logs[index].data ?? "";
        
                        let tokenAmountInWei = web3.utils.hexToNumberString(tokenHexString);
            
                        let abi = [
                          "function balanceOf(address owner) view returns (uint256)",
                          "function transfer(address to, uint256 amount) returns (bool)",
                          "function decimals() view returns (uint8)",
                        ];
            
                        let wallet = new ethers.Wallet(process.env.ADMIN_PRIVATE_KEY, provider);
            
                        let ethContract = await new ethers.Contract(tokenAddress, abi, wallet);
                        let decimals = await ethContract.decimals();
            
                        let tokenAmount = parseFloat(tokenAmountInWei) / Math.pow(10, decimals);

                        // console.log(`Token Tx: Amount: ${amount} | Expected: ${expectedAmount}`);
      
                        if (tokenAmount == expectedAmount) {
                          found = true;
                          console.log(`✅ Matching token transaction found: ${tx.hash}`);
      
                          if (automaticHash) {
                            formRef.current.setFieldValue("transaction_hash", tx.hash);
                            onSubmit({ ...formRef.current.values, transaction_hash: tx.hash });
                          }
      
                          provider.off("block", blockListener);
                          setMonitoring(false);
                          break;
                        }
                      }
                    }
                  }
                }
            } while (transReceipt.logs.length > 0)
          }
        }
      }
    };
    provider.on("block", blockListener); 
  };

  useEffect(() => {
    if (!skipRender && !adminWallet.loading && Object.keys(adminWallet.data).length > 0) {
      console.log(tokenExchangeData.from_currency)
      const wallet_address = adminWallet.data.admin_crypto_account.wallet_address;
      let token = ["USDT", "USDC"].includes(tokenExchangeData.from_currency) ? tokenExchangeData.from_network_type : tokenExchangeData.from_currency;
      let currency = tokenExchangeData.from_currency;
      let expected_amount = tokenExchangeData.from_amount;
      setMonitoring(true);
      console.log(tokenExchangeData, token)
      if (token == "TRX") {
        socket = io(SOCKET_URL);
        const rpcUrl = SUPPORTED_RPC_URLS[SupportedTokens[process.env.REACT_APP_NODE_ENV == "production" ? token : "SHASTA"]];
        if(["USDT", "USDC"].includes(currency)){
          let contract_address = SPECIAL_CONTRACT_ADDRESS[process.env.REACT_APP_NODE_ENV == "production" ? token : "SHASTA"][currency];
          setTronMonitoring({
            walletAddress: wallet_address,
            expectedAmount: expected_amount,
            rpcUrl: rpcUrl,
            tokenAddress: contract_address,
          })
        } else {
          setTronMonitoring({
            walletAddress: wallet_address,
            expectedAmount: expected_amount,
            rpcUrl: rpcUrl,
            tokenAddress: null,
          })
        }
      } else if(token == "SOL") {
        socket = io(SOCKET_URL);
        const rpcUrl = SUPPORTED_RPC_URLS[SupportedTokens[token]]; 
        setSolanaMonitoring({
          walletAddress: wallet_address,
          expectedAmount: expected_amount,
          rpcUrl: rpcUrl
        })
      }
       else {
        if(["USDT", "USDC"].includes(currency)){
          let contract_address = SPECIAL_CONTRACT_ADDRESS[token][currency];
          startMonitoring(wallet_address, token, expected_amount, contract_address);
        } else {
          startMonitoring(wallet_address, token, expected_amount, null);
        }
      }
      generateQRDetails(adminWallet.data.admin_crypto_account.wallet_address, token, tokenExchangeData.from_currency);
    }
    setSkipRender(false);
  }, [adminWallet, tokenExchangeData])

  useEffect(() => {
      if (socket && Object.keys(tronMonitoring).length > 0) {
        console.log("Monitoring Tron Transactions Started")
        socket.emit("subscribeTransactionMonitoring", {
          walletAddress: tronMonitoring.walletAddress,
          expectedAmount: tronMonitoring.expectedAmount,
          networkUrl: tronMonitoring.rpcUrl,
          tokenAddress: tronMonitoring.tokenAddress
        });
      }
  
      socket && socket.on("transactionDetected", (data) => {
        console.log("Transaction detected:", data);
        if(automaticHash){
          formRef.current.setFieldValue("transaction_hash", data.txID)
          onSubmit({
            ...formRef.current.values,
            transaction_hash: data.txID
          })
        }
        setMonitoring(false);
      });
  
      return () => {
        // socket.disconnect();
      };
  }, [tronMonitoring, socket]);

  useEffect(() => {
    if (socket && Object.keys(solanaMonitoring).length > 0) {
      console.log("Monitoring Solana Transactions Started")
      socket.emit("subscribeSolanaTransactionMonitoring", {
        walletAddress: solanaMonitoring.walletAddress,
        expectedAmount: solanaMonitoring.expectedAmount,
        networkUrl: solanaMonitoring.rpcUrl,
      });
    }

    socket && socket.on("solanaTransactionDetected", (data) => {
      console.log("Transaction detected:", data);
      if(automaticHash){
        formRef.current.setFieldValue("transaction_hash", data.txID)
        onSubmit({
          ...formRef.current.values,
          transaction_hash: data.txID
        })
      }
      setMonitoring(false);
    });

    return () => {
      // socket.disconnect();
    };
  }, [solanaMonitoring, socket]);

  const handleManualHash = () => {
    setMonitoring(false);
    setAutomaticHash(false);
  }

  return (

    <>
      {adminWallet.loading ?
        <CommonCenterLoader />
        :
        Object.keys(adminWallet.data).length > 0 &&(adminWallet.data?.admin_crypto_account.qr_code||adminWallet.data?.admin_crypto_account.wallet_address) ? (
          <>
            <div className="bank-account-details-sec">
              <div className="bank-account-details out_space_mx_1_5">
                <div
                  className="back-arrow-btn-sec"
                  onClick={() =>
                    updateTokenExchangeData({ ...tokenExchangeData, step: 1 })
                  }
                >
                  <Image
                    src={window.location.origin + "/img/exchange/back-arrow-icon.svg"}
                    className="back-arrow-btn"
                  />
                  <h4>{t("exchange_crypto")} </h4>
                </div>
              </div>
              <div className="auth-qr-details-swap-frame">
                <div className="deposit-amt-details mb-0 p-0">
                  <div className="deposit-amt-details-info out_space_mx_1_5">
                    <div className="deposit-amt-pay" >
                      <span className="amt-pay-label">{t("you_pay.name")} </span>
                      <span className="amt-pay-amt">{tokenExchangeData.from_amount} {tokenExchangeData.from_currency}
                        {" "} {(["USDT", "USDC"].includes(tokenExchangeData.from_currency) && tokenExchangeData.from_network_type) ? `(${tokenExchangeData.from_network_type})` : ""}
                      </span>
                    </div>
                    <div className="deposit-amt-get">
                      <span className="amt-pay-label">{t("you_get.name")}</span>
                      <span className="amt-pay-amt">{tokenExchangeData.to_currency_conversion_value} {tokenExchangeData.to_currency}
                        {" "} {(["USDT", "USDC"].includes(tokenExchangeData.to_currency) && tokenExchangeData.to_network_type) ? `(${tokenExchangeData.to_network_type})` : ""}
                      </span>
                    </div>
                  </div>
                  <div className="efi-swap-exchange-info efi-info-frame">
                    <p>
                      {" "}
                      <span>{t("estimated_rate")}</span>{" "}
                      < span >
                        1 {tokenExchangeData.from_currency} = {!isNaN(tokenExchangeData.to_currency_conversion_value) ? (tokenExchangeData.to_currency_conversion_value / tokenExchangeData.from_amount).toFixed(8) : 0.0000} {tokenExchangeData.to_currency}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="auth_deposit_qr_scan">
                  <div
                    className="admin-wallet-qr-frame"
                  >
                      {/* {adminWallet.data?.admin_crypto_account?.qr_code ?
                        <CustomLazyLoad
                          src={adminWallet.data?.admin_crypto_account.qr_code}
                          className="qr-code-payment-image"

                        />
                        : (
                          <QRCode
                            size={135}
                            value={adminWallet.data?.admin_crypto_account.wallet_address}
                            viewBox={`0 0 256 256`}
                          />
                      )} */}
                      {generatedQr ?
                        <Image src={generatedQr} />
                        : <Skeleton height={200} width={200} />}
                  </div>
                </div>
              </div>
            </div>
            <Formik
              initialValues={{
                transaction_hash: "",
              }}
              validationSchema={validationSchema}
              innerRef={formRef}
              onSubmit={(values) => onSubmit(values)}
            >
              {({ values, touched, errors, setFieldValue }) => (
                <FORM>
                  <div className="deposit_modal_form">
                    <div className="sell_address_card  out_space_mx_1_5">
                    {adminWallet.data?.admin_crypto_account?.wallet_address &&
                      <div className="buy-data-card mb-3">
                        <h6>{t("wallet_address")}</h6>
                        <div className="auth_buy_code">
                          <div className="auth_deposit_code_card">
                            <span>
                              {" "}
                              {adminWallet.data?.admin_crypto_account?.wallet_address}
                            </span>{" "}
                          </div>

                          <CopyToClipboard
                            text={adminWallet.data?.admin_crypto_account?.wallet_address}
                            onCopy={(e) =>
                              getSuccessNotificationMessage("Wallet Address Copied!")
                            }
                          >
                            <Button className="action-btn overlay item_center_column p-0">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#298BFF"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="icon icon-tabler icons-tabler-outline icon-tabler-copy"
                              >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M7 7m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
                                <path d="M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
                              </svg>
                            </Button>
                          </CopyToClipboard>
                        </div>
                      </div>}
                      <div className="deposit_address_field">
                        <Form.Group controlId="formBasicEmail">
                          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
                            <Form.Label>
                              {t("transaction.label")} <span>*</span>
                            </Form.Label>
                            {automaticHash ? <Button variant="link" style={{fontSize:"0.8em"}} onClick={()=> handleManualHash()}>
                              Enter Manually
                            </Button> : null}
                          </div>
                          <Field
                            className="form-control"
                            type="text"
                            placeholder={t("transaction.placeholder")}
                            name="transaction_hash"
                            // disabled={exchangeCrypto.buttonDisable}
                            disabled={automaticHash}
                          />
                          <ErrorMessage
                            component={"div"}
                            name="transaction_hash"
                            className="text-danger text-right"
                          />
                        </Form.Group>
                      </div>
                    </div>
                    {monitoring ? <AwaitingStepper monitoring={monitoring}/> : exchangeCryptoHD.buttonDisable || (Object.keys(exchangeCryptoHD.data).length > 0 && transactionSuccess&&!buttonShow) ? 
                    <ButtonStepper status={exchangeCryptoHD.data.exchange?.status ? exchangeCryptoHD.data.exchange?.status : 0} /> :
                      <div className="deposit_amount_action item_flex_x_5">
                        <Button
                          className="action-btn primary w-100"
                          type="submit"
                          disabled={exchangeCryptoHD.buttonDisable}
                        >
                          {t("continue")}
                        </Button>
                      </div>}
                    <div className="deposit_bank_action">
                      <p className="out_space_mt_1 other_links">
                        {t("by_continuing_you_agree_to_our")}{" "}
                        <Link className="cookie-txt" to="/page/privacy-agreement">
                          {t("cookie_policy")}.
                        </Link>
                      </p>
                    </div>
                  </div>
                </FORM>
              )}
            </Formik>
          </>
        ) : (
          <>
            <div className="bank-account-details out_space_mx_1_5">
              <div
                className="back-arrow-btn-sec"
                onClick={() => updateTokenExchangeData({ ...tokenExchangeData, step: 1 })}
              >
                <Image
                  src={window.location.origin + "/img/exchange/back-arrow-icon.svg"}
                  className="back-arrow-btn"
                />
                <h4>{t("sell_crypto")} </h4>
              </div>
            </div>
            <div className="no-bank-details-sec exchange-btn-sec">
              <CustomLazyLoad
                src={window.location.origin + "/img/no-bank-found.png"}
                className="no-data-found-img"
              />
              <p>{t("no_wallet_details_found")}</p>
              <div>
                <Button
                  className="action-btn primary w-100"
                  onClick={() => dispatch(getAdminWalletStart({ network_type: !["USDT", "USDC"].includes(tokenExchangeData.from_currency) ? tokenExchangeData.from_currency : tokenExchangeData.from_network_type }))}
                >
                  {t("retry")}
                </Button>
              </div>
            </div>
          </>
        )
      }
    </>

  );
};

export default ExchangeWithoutLogin;